import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.disable = {
    update: function(element, va, bindings, model, context) {
        var dis = false;
        var _va = ko.unwrap(va());
        if (!_va)
            dis = true;
        if (Object.isObject(_va)) {
            var perms = ko.unwrap(_va.perm),
            bind = ko.unwrap(_va.bind),
            pref = ko.unwrap(_va.prefix);
            if (perms)
                dis = bind;
            else dis = bind;
        }
        else dis = _va;

        ko.bindingHandlers.enable.update(element, function() { return !dis; }, bindings, model, context);
    }
};
